// extracted by mini-css-extract-plugin
module.exports = {"container":"AdminListOrders_container__Ob79W","title":"AdminListOrders_title__UlqR2","table":"AdminListOrders_table__2JK3z","uuid":"AdminListOrders_uuid__31AyK"};